import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#FF8000',
    pc: {
        background: '/features/buffalo-fs-20261014/pc_bg.jpg',
        overlay: 'rgba(40, 24, 10, 0.85)',
        eyebrow: '求人特集',
        titleLines: ['株式会社', 'バッファロー', 'フードサービス'],
        contentsColor: '#030D22',
    },
    hero: {
        image: '/features/buffalo-fs-20261014/hero.jpg',
        alt: 'バッファロー フードサービス 求人特集 急成長中のPISOLAブランド積極募集！',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            { text: 'ぜんぶ、' },
            { text: '笑顔', accent: true },
            { text: 'に。' },
            { text: '変えていこうぜ。', breakBefore: true },
        ],
        paragraphs: [
            { text: 'お客様の笑顔が、働く私たちの元気になる。' },
            {
                text: '「食」を通じて笑顔と元気を届けることを',
                breakBefore: true,
            },
            { text: '大切にしています。', breakBefore: true },
            {
                text: '誰かを笑顔にすることが、自分の喜びややりがい',
                breakBefore: true,
            },
            { text: 'にもつながる仕事です。', breakBefore: true },
        ],
    },
    thumbnail: {
        image: '/features/buffalo-fs-20261014/top_sub.jpg',
        alt: 'PISOLAの看板がある店舗、2人のスタッフ、ピザの3枚の写真',
    },
    featuresTitle: ['バッファローフードサービス', 'で働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: ['大手グループの安定基盤のもと、', 'さらなる成長へ'],
            body: [
                '大手カー用品店のFC事業を展開する「株式会社バッファロー」の100％子会社として、安定した経営基盤を確立。埼玉を中心に年間2～3店舗の新規出店を進め、安定性と成長性を兼ね備えた環境でキャリアアップを目指せます。',
            ],
            image: '/features/buffalo-fs-20261014/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['高水準の給与と充実した待遇が、', '働くモチベーションに'],
            body: [
                '給与は月27～45万円と、ポジションや経験に応じて設定。業績賞与を年2回支給し、昇給の機会も年2回設けています。家族手当・住宅手当・役職手当など、生活とキャリアの両面を支える各種制度も整えています。',
            ],
            image: '/features/buffalo-fs-20261014/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['働きやすさも、キャリアアップも', '叶えられる環境'],
            body: [
                '週休2日制に加え、夏季・冬季の特別休暇もご用意。勤務時間や待遇が明確な環境で、安心して働けます。仕事とプライベートのメリハリをつけながら、長くキャリアを築ける環境です。',
            ],
            image: '/features/buffalo-fs-20261014/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    jobs: {
        eyebrow: 'pickup',
        title: ['バッファローフードサービス', '求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'store-manager',
                categoryLabel: '店長・店長候補',
                variant: 'carousel',
                description:
                    '店舗運営を幅広く担当いただきます。あなたの経験やスキルを活かした店舗づくりをお任せします！',
                jobs: [
                    {
                        offerId: '87342',
                        badgeLabel: 'イタリアン,ファミレス｜店長・店長候補',
                        title: '【労働環境・福利厚生◎】安定企業が運営するバリ島イタリアンの店長候補を募集',
                        brandName: 'PISOLA 熊谷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '熊谷市',
                        image: '/features/buffalo-fs-20261014/job_card_01_01.jpg',
                        href: 'https://foods-labo.com/offers/87342',
                        analyticsLabel: 'CT_Jobinformation_求人例-店長候補-1st',
                    },
                    {
                        offerId: '79056',
                        badgeLabel: 'イタリアン,ファミレス｜店長・店長候補',
                        title: '【神奈川＊安定企業＊賞与年2回＊週休2日】人気イタリアンチェーンの店長候補',
                        brandName: 'PISOLA 横須賀店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横須賀市',
                        image: '/features/buffalo-fs-20261014/job_card_01_02.jpg',
                        href: 'https://foods-labo.com/offers/79056',
                        analyticsLabel: 'CT_Jobinformation_求人例-店長候補-2nd',
                    },
                    {
                        offerId: '89539',
                        badgeLabel: 'イタリアン,ファミレス｜店長・店長候補',
                        title: '店長・店長候補を募集★★上場企業グループ／月8〜10休／福利厚生充実★★',
                        brandName: 'PISOLA 戸田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '戸田市',
                        image: '/features/buffalo-fs-20261014/job_card_01_03.jpg',
                        href: 'https://foods-labo.com/offers/89539',
                        analyticsLabel: 'CT_Jobinformation_求人例-店長候補-3rd',
                    },
                    {
                        offerId: '79051',
                        badgeLabel: 'イタリアン,ファミレス｜店長・店長候補',
                        title: '⭐️福利厚生多数！労働環境安定！⭐️人気レストラン「PISOLA」店長候補',
                        brandName: 'PISOLA 成田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '成田市',
                        image: '/features/buffalo-fs-20261014/job_card_01_04.jpg',
                        href: 'https://foods-labo.com/offers/79051',
                        analyticsLabel: 'CT_Jobinformation_求人例-店長候補-4th',
                    },
                    {
                        offerId: '78913',
                        badgeLabel: 'イタリアン,ファミレス｜店長・店長候補',
                        title: '《人気イタリアンチェーンの店長候補》母体安定＊月給30万〜＊福利厚生充実',
                        brandName: 'PISOLA 三郷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '三郷市',
                        image: '/features/buffalo-fs-20261014/job_card_01_05.jpg',
                        href: 'https://foods-labo.com/offers/78913',
                        analyticsLabel: 'CT_Jobinformation_求人例-店長候補-5th',
                    },
                ],
            },
            {
                id: 'hall',
                categoryLabel: 'ホールスタッフ',
                variant: 'carousel',
                description:
                    '接客業務・調理業務を兼任でお任せします。お客様との会話を楽しみながら、あなたらしい接客ができるお仕事です！',
                jobs: [
                    {
                        offerId: '78915',
                        badgeLabel:
                            'イタリアン,ファミレス｜レストランサービス・ホールスタッフ',
                        title: '《お洒落イタリアンのホール募集》飲食未経験歓迎＊入社祝い金＊労働環境◎',
                        brandName: 'PISOLA 三郷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '三郷市',
                        image: '/features/buffalo-fs-20261014/job_card_02_01.jpg',
                        href: 'https://foods-labo.com/offers/78915',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-1st',
                    },
                    {
                        offerId: '87352',
                        badgeLabel:
                            'イタリアン,ファミレス｜レストランサービス・ホールスタッフ',
                        title: '《母体安定＊未経験可＊入社祝金》人気レストラン「PISOLA」ホールを募集',
                        brandName: 'PISOLA 熊谷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '熊谷市',
                        image: '/features/buffalo-fs-20261014/job_card_02_02.jpg',
                        href: 'https://foods-labo.com/offers/87352',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-2nd',
                    },
                    {
                        offerId: '79058',
                        badgeLabel:
                            'イタリアン,ファミレス｜レストランサービス・ホールスタッフ',
                        title: '《安定企業＊月8〜10日休＊福利厚生充実》おしゃれイタリアンのホールを募集',
                        brandName: 'PISOLA 横須賀店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横須賀市',
                        image: '/features/buffalo-fs-20261014/job_card_02_03.jpg',
                        href: 'https://foods-labo.com/offers/79058',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-3rd',
                    },
                    {
                        offerId: '89537',
                        badgeLabel:
                            'イタリアン,ファミレス｜レストランサービス・ホールスタッフ',
                        title: '《ホール募集》安定企業＊未経験OK＊労働環境良し＊おしゃれ自由＊入社祝い金',
                        brandName: 'PISOLA 戸田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '戸田市',
                        image: '/features/buffalo-fs-20261014/job_card_02_04.jpg',
                        href: 'https://foods-labo.com/offers/89537',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-4th',
                    },
                    {
                        offerId: '79053',
                        badgeLabel:
                            'イタリアン,ファミレス｜レストランサービス・ホールスタッフ',
                        title: '【おしゃれなレストランで働きませんか？】月8〜10日休み＊髪型・ネイル自由',
                        brandName: 'PISOLA 成田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '成田市',
                        image: '/features/buffalo-fs-20261014/job_card_02_05.jpg',
                        href: 'https://foods-labo.com/offers/79053',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-5th',
                    },
                ],
            },
            {
                id: 'kitchen',
                categoryLabel: 'キッチンスタッフ',
                variant: 'carousel',
                description:
                    '調理業務・接客業務を兼任でお任せします。料理は手作りにこだわっており、調理の基礎や食材の知識を身につけられます。',
                jobs: [
                    {
                        offerId: '89538',
                        badgeLabel: 'イタリアン,ファミレス｜キッチンスタッフ',
                        title: '⭐️整った労働環境＊おしゃれ自由⭐️安定企業でキャリアを積んでみませんか？',
                        brandName: 'PISOLA 戸田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '戸田市',
                        image: '/features/buffalo-fs-20261014/job_card_03_01.jpg',
                        href: 'https://foods-labo.com/offers/89538',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-1st',
                    },
                    {
                        offerId: '78916',
                        badgeLabel: 'イタリアン,ファミレス｜キッチンスタッフ',
                        title: '【入社祝金3万円/未経験OK/労働環境安定】人気レストラン「PISOLA」',
                        brandName: 'PISOLA 三郷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '三郷市',
                        image: '/features/buffalo-fs-20261014/job_card_03_02.jpg',
                        href: 'https://foods-labo.com/offers/78916',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-2nd',
                    },
                    {
                        offerId: '79059',
                        badgeLabel: 'イタリアン,ファミレス｜キッチンスタッフ',
                        title: '《キッチン募集》おしゃれ店舗＊月8〜10日休み＊福利厚生充実＊未経験OK',
                        brandName: 'PISOLA 横須賀店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横須賀市',
                        image: '/features/buffalo-fs-20261014/job_card_03_03.jpg',
                        href: 'https://foods-labo.com/offers/79059',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-3rd',
                    },
                    {
                        offerId: '79054',
                        badgeLabel: 'イタリアン,ファミレス｜キッチンスタッフ',
                        title: '◆イタリアンのキッチンスタッフ募集◆成田市＊母体安定＊労働環境・福利厚生◎',
                        brandName: 'PISOLA 成田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '成田市',
                        image: '/features/buffalo-fs-20261014/job_card_03_04.jpg',
                        href: 'https://foods-labo.com/offers/79054',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-4th',
                    },
                    {
                        offerId: '87354',
                        badgeLabel: 'イタリアン,ファミレス｜キッチンスタッフ',
                        title: '【イタリアン／キッチンスタッフ募集】労働環境安定＊髪型・髪色自由＊入社祝金',
                        brandName: 'PISOLA 熊谷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '熊谷市',
                        image: '/features/buffalo-fs-20261014/job_card_03_05.jpg',
                        href: 'https://foods-labo.com/offers/87354',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-5th',
                    },
                ],
            },
            {
                id: 'area-manager',
                categoryLabel: 'エリアマネージャー',
                variant: 'carousel',
                description:
                    '店舗運営に関わるマネジメント業務を担当いただきます。これまでの経験やスキルを活かした店舗づくりをお任せします！',
                jobs: [
                    {
                        offerId: '122629',
                        badgeLabel: 'イタリアン,ファミレス｜エリアマネージャー',
                        title: '《人気イタリアンチェーンのエリアMGRを募集》安定企業＊労働環境安定',
                        brandName: 'PISOLA 戸田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '戸田市',
                        image: '/features/buffalo-fs-20261014/job_card_04_01.jpg',
                        href: 'https://foods-labo.com/offers/122629',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-エリアマネージャー-1st',
                    },
                    {
                        offerId: '122628',
                        badgeLabel: 'イタリアン,ファミレス｜エリアマネージャー',
                        title: '《即戦力採用＊母体超安定＊福利厚生◎》未来の拡大に向けてエリアMGRを募集',
                        brandName: 'PISOLA 成田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '成田市',
                        image: '/features/buffalo-fs-20261014/job_card_04_02.jpg',
                        href: 'https://foods-labo.com/offers/122628',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-エリアマネージャー-2nd',
                    },
                    {
                        offerId: '122626',
                        badgeLabel: 'イタリアン,ファミレス｜エリアマネージャー',
                        title: '【PISOLAの店舗統括職候補】上場企業グループ｜労働環境・福利厚生◎',
                        brandName: 'PISOLA 三郷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '三郷市',
                        image: '/features/buffalo-fs-20261014/job_card_04_03.jpg',
                        href: 'https://foods-labo.com/offers/122626',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-エリアマネージャー-3rd',
                    },
                    {
                        offerId: '122630',
                        badgeLabel: 'イタリアン,ファミレス｜エリアマネージャー',
                        title: '《即戦力を募集＊福利厚生充実》店舗拡大中！人気イタリアン「PISOLA」',
                        brandName: 'PISOLA 横須賀店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横須賀市',
                        image: '/features/buffalo-fs-20261014/job_card_04_04.jpg',
                        href: 'https://foods-labo.com/offers/122630',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-エリアマネージャー-4th',
                    },
                    {
                        offerId: '122631',
                        badgeLabel: 'イタリアン,ファミレス｜エリアマネージャー',
                        title: '【店舗拡大中！バリ島イタリアン◆エリアMGR募集】母体安定＊月8〜10日休',
                        brandName: 'PISOLA 熊谷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '30~45',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '熊谷市',
                        image: '/features/buffalo-fs-20261014/job_card_04_05.jpg',
                        href: 'https://foods-labo.com/offers/122631',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-エリアマネージャー-5th',
                    },
                ],
            },
            {
                id: 'cooking-assistant',
                categoryLabel: '調理見習い・調理補助',
                variant: 'carousel',
                description:
                    '未経験も歓迎！接客業務を兼任しながら、手作りの料理にこだわった調理基礎や食材の知識を身につけることができます。',
                jobs: [
                    {
                        offerId: '122632',
                        badgeLabel:
                            'イタリアン,ファミレス｜調理見習い・調理補助',
                        title: '【若手キッチン募集】未経験でも大丈夫＊オシャレ店舗＊髪型・髪色自由',
                        brandName: 'PISOLA 熊谷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '熊谷市',
                        image: '/features/buffalo-fs-20261014/job_card_05_01.jpg',
                        href: 'https://foods-labo.com/offers/122632',
                        analyticsLabel: 'CT_Jobinformation_求人例-調理補助-1st',
                    },
                    {
                        offerId: '122633',
                        badgeLabel:
                            'イタリアン,ファミレス｜調理見習い・調理補助',
                        title: '《未経験OK＊入社祝い金3万円＊福利厚生充実》安定企業が運営する人気店',
                        brandName: 'PISOLA 横須賀店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '神奈川県',
                        city: '横須賀市',
                        image: '/features/buffalo-fs-20261014/job_card_05_02.jpg',
                        href: 'https://foods-labo.com/offers/122633',
                        analyticsLabel: 'CT_Jobinformation_求人例-調理補助-2nd',
                    },
                    {
                        offerId: '122634',
                        badgeLabel:
                            'イタリアン,ファミレス｜調理見習い・調理補助',
                        title: '【人柄採用＊安定の労働環境】おしゃれなイタリアンレストランで働きませんか？',
                        brandName: 'PISOLA 戸田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '戸田市',
                        image: '/features/buffalo-fs-20261014/job_card_05_03.jpg',
                        href: 'https://foods-labo.com/offers/122634',
                        analyticsLabel: 'CT_Jobinformation_求人例-調理補助-3rd',
                    },
                    {
                        offerId: '122635',
                        badgeLabel:
                            'イタリアン,ファミレス｜調理見習い・調理補助',
                        title: '【イタリアンレストランの若手スタッフ】未経験OK＊福利厚生充実＊母体安定',
                        brandName: 'PISOLA 成田店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '千葉県',
                        city: '成田市',
                        image: '/features/buffalo-fs-20261014/job_card_05_04.jpg',
                        href: 'https://foods-labo.com/offers/122635',
                        analyticsLabel: 'CT_Jobinformation_求人例-調理補助-4th',
                    },
                    {
                        offerId: '122636',
                        badgeLabel:
                            'イタリアン,ファミレス｜調理見習い・調理補助',
                        title: '《若手スタッフ募集＊未経験OK＊労働環境安定＊おしゃれ自由＊入社祝い金》',
                        brandName: 'PISOLA 三郷店',
                        brandLogo: '/features/buffalo-fs-20261014/logo_01.png',
                        salary: '27~33',
                        salaryUnit: '月収',
                        prefecture: '埼玉県',
                        city: '三郷市',
                        image: '/features/buffalo-fs-20261014/job_card_05_05.jpg',
                        href: 'https://foods-labo.com/offers/122636',
                        analyticsLabel: 'CT_Jobinformation_求人例-調理補助-5th',
                    },
                ],
            },
        ],
    },
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
}
